// assets
import fiveStarsFull from '@/static/assets/customer_reviews/pink_5_stars_large.png';
import fiveStarsFullSm from '@/static/assets/customer_reviews/pink_5_stars_small.png';
import fiveStarsShowFull from '@/static/assets/customer_reviews/stars_full.svg';
import fiveStarsEmpty from '@/static/assets/customer_reviews/stars_full_bg.svg';
import { Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import styled from 'styled-components';

interface StarProps {
  readonly showFullStars: boolean;
  readonly scrolledTo: boolean;
}

export const Stars = styled(Flex)<StarProps>`
  height: 56px;
  width: 336px;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${fiveStarsEmpty.src});
  margin: 50px 0;
  &:before {
    content: '';
    height: 100%;
    width: ${({ scrolledTo }: { readonly scrolledTo: boolean }) => (scrolledTo ? '100%' : '0')};
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(${({ showFullStars }) => (showFullStars ? fiveStarsShowFull.src : fiveStarsFullSm.src)});
    transform: translateZ(0);
    transition: width 1.7s ease-out;
    will-change: width;
    display: inline-table;
  }

  ${MEDIA_QUERIES.mobile`
        width: 325px;
        height: 54px;

        &:before {
            background-repeat: no-repeat;
            background-size: cover;
            background-image: url(${({ showFullStars }: { readonly showFullStars: boolean }) =>
              showFullStars ? fiveStarsShowFull.src : fiveStarsFull.src});

        }
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        width: 685px;
        height: 114px;

        &:before {
            background-repeat: no-repeat;
            background-size: cover;
            background-image: url(${({ showFullStars }: { readonly showFullStars: boolean }) =>
              showFullStars ? fiveStarsShowFull.src : fiveStarsFull.src});
        }
    `}
`;
